import styled from 'styled-components'
import { Row, Carousel } from 'antd'

export const StyledSearchBarWrapper = styled(Row)`
  height: 150px;
  width: 100%;
  background-image: url('/images/categories-bg.png');
  background-repeat: no-repeat;
  background-position: center;
`

export const StyledSuggestedProductsWrapper = styled(Row)`
  h2 {
    color: var(--cognac);
  }
`
export const StyledSearchResultsWrapper = styled(Row)`
  margin-bottom: 45px;
  h2 {
    color: var(--cognac);
  }
  .no-result {
    padding: 100px 0;
    text-align: center;
  }
  /* .results {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-gap: 22px;
  }
   */
  @media only screen and (max-width: 768px) {
    /* .results {
      display: flex !important;
      flex-direction: column;
      flex-wrap: nowrap !important;
      width:  100%;
      .ant-col {
        max-height: 200px !important;
      }
    } */
  }
`
export const StyledMobileSuggestedCarousel = styled(Carousel)`
  margin-bottom:  25px;
  .slick-dots,
  .slick-dots-bottom {
    bottom: -24px;
  }
  .slick-dots > li > button {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: var(--grey);
  }
  .slick-dots {
    li { width: 12px !important; }
    li,
    button {
      width: 12px;
      height: 12px;
      &.slick-active > button, li {
        background-color: var(--orange-peel) !important;
      }
    }
  }
`
